export default __webpack_public_path__ + "static/ecosystem@2x-6961ecd93ad57df631c2ced50f7e8f75.png";